import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import WaitlistProgramSelectorModal from '../../classes/program-dashboard-manager/enrollments-tab/waitlist/modals/WaitlistProgramSelectorModal'
import SuccessModal from '../../common/customModal/SuccessModal'
import TransferConfirmationModal from './TransferConfirmationModal'

// The transfer flow: pick a program (the waitlist selector), confirm, then the success modal.
// Shared by the Enrollments & Billing drawer and the Members drawer's Enrollments tab.
const TransferModals = ({
  enrollment, showTransfer, showTransferConfirm, showTransferSuccess, selectedCourse,
  onSelectProgram, closeTransfer, onProceedToConfirm, onConfirmTransfer, closeTransferSuccess, isLoading,
}) => {
  const { t } = useTranslation()
  return (
    <>
      {showTransfer && enrollment?.course && (
        <WaitlistProgramSelectorModal
          isOpen={showTransfer}
          title={t('enrollmentsBilling.drawer.transferToAnotherProgram')}
          currentProgram={enrollment.course}
          selectedProgram={selectedCourse}
          onSelectProgram={onSelectProgram}
          students={enrollment.student ? [enrollment.student] : []}
          onClose={closeTransfer}
          onProceed={onProceedToConfirm}
        />
      )}

      {showTransferConfirm && enrollment && (
        <TransferConfirmationModal
          isOpen
          enrollment={enrollment}
          onClose={closeTransfer}
          onConfirm={onConfirmTransfer}
          isLoading={isLoading}
        />
      )}

      <SuccessModal
        isOpen={showTransferSuccess}
        onClose={closeTransferSuccess}
        title={t('enrollmentsBilling.drawer.enrollmentTransferred')}
        buttonMessage={t('enrollmentsBilling.drawer.close')}
      />
    </>
  )
}

TransferModals.propTypes = {
  enrollment: PropTypes.object,
  showTransfer: PropTypes.bool,
  showTransferConfirm: PropTypes.bool,
  showTransferSuccess: PropTypes.bool,
  selectedCourse: PropTypes.object,
  onSelectProgram: PropTypes.func.isRequired,
  closeTransfer: PropTypes.func.isRequired,
  onProceedToConfirm: PropTypes.func.isRequired,
  onConfirmTransfer: PropTypes.func.isRequired,
  closeTransferSuccess: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

export default TransferModals
